import React from 'react'

export default class About extends React.Component {
    render() {
        return (
            <div>
                <h2>WRF</h2>

                <p>Info about WRF.</p>
                <h3>Helpful User Guides</h3>
                <li>
                    <a href="https://www2.mmm.ucar.edu/wrf/users/" target = "_blank">WRF Model Users' Page</a>
                </li>
                <br></br>
                <h4>Major Updates</h4>
                2025-11-07 : Add WRF to AQcast.

            </div>
        );
    }
}
